if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input_country: this.querySelector('input[name="country_code"]'),
        input_language: this.querySelector('input[name="locale_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
	  if(this.elements.button){
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
	  }
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      if(this.elements.button) this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements?.button?.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      if(event.target.closest('form') && event.target.closest('form').id == 'HeaderLanguageForm'){
        this.elements.input_language.value = event.currentTarget.dataset.value;
      } else if(event.target.closest('form')){
        this.elements.input_country.value = event.currentTarget.dataset.value;
        console.log(this.elements.input_country)
      }
      console.log(event.target, event.target.closest('form'),this.elements.input_country,event.currentTarget.dataset.value)
       if (event.target.closest('form')) {
		localStorage.removeItem('saftkur-bundle');
		event.target.closest('form').submit();
	}
    }

    openSelector() {
      if(this.elements.button) this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const isChild = this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
      if (!event.relatedTarget || !isChild) {
        this.hidePanel();
      }
    }
  });
}
